module.exports = __webpack_public_path__ + "img/政策与制度_05.12ca6425.jpg";